import CantileverButton from 'components/CantileverButton'
import { useChartSlashCommandContext } from 'features/richText/contexts/ChartSlashCommandContext'
import { TimeSeriesScatterplot, useResolvedChart } from 'features/timeSeries'
import React, { useState } from 'react'
import styled from 'styled-components'

import { SlashCommandCardProps } from './DefaultSlashCommandCard'
import {
  SlashCommandCard,
  SlashCommandCardBody,
  SlashCommandCardHeader,
  SlashCommandCardIcon,
  SlashCommandCardInfo,
  SlashCommandCardMeta,
  SlashCommandCardName,
  SlashCommandCardType,
  SlashCommandChip,
  SlashCommandChipIcon,
  SlashCommandModal,
  SlashCommandModalBody,
  SlashCommandModalContent,
  SlashCommandModalHeader,
} from './sharedStyles'

const ChartContainer = styled.div`
  height: 20rem;
  background: ${({ theme }) => theme.forecast.cardBackground};
  border-radius: 0.25rem;
  margin: 1rem;
  display: flex;
  flex-direction: column;
`

export const ChartSlashCommandCard: React.FC<SlashCommandCardProps> = ({
  entryType,
  entryID,
  entryName,
  isEditMode,
  metadata,
}) => {
  const [showModal, setShowModal] = useState(false)
  const { forceRichDisplay } = useChartSlashCommandContext()

  const handleCloseModal = () => {
    setShowModal(false)
  }
  const siteID = metadata?.siteId

  const { chart } = useResolvedChart(entryID)

  const handleClick = () => {
    if (isEditMode) {
      setShowModal(true)
    }
  }

  if (isEditMode && !forceRichDisplay) {
    return (
      <>
        <SlashCommandChip
          onClick={handleClick}
          title={`${entryType}: ${entryName}`}>
          <SlashCommandChipIcon>C</SlashCommandChipIcon>
          {entryName}
        </SlashCommandChip>
        {showModal && (
          <SlashCommandModal onClick={handleCloseModal}>
            <SlashCommandModalContent onClick={(e) => e.stopPropagation()}>
              <SlashCommandModalHeader>
                Metadata for Chart
              </SlashCommandModalHeader>
              <SlashCommandModalBody>
                <p>
                  <strong>Entry:</strong> {entryName}
                </p>
                <p>
                  <strong>ID:</strong> {entryID}
                </p>
                {chart?.name && (
                  <p>
                    <strong>Name:</strong> {chart?.name}
                  </p>
                )}
                {chart?.description && (
                  <p>
                    <strong>Description:</strong> {chart?.description}
                  </p>
                )}
              </SlashCommandModalBody>
              <CantileverButton primary onClick={handleCloseModal}>
                Close
              </CantileverButton>
            </SlashCommandModalContent>
          </SlashCommandModal>
        )}
      </>
    )
  }

  // In view mode, show rich display
  return (
    <SlashCommandCard $isEditMode={false} $disableHovering={true}>
      <SlashCommandCardHeader>
        <SlashCommandCardIcon>C</SlashCommandCardIcon>
        <SlashCommandCardInfo>
          <SlashCommandCardName>{entryName}</SlashCommandCardName>
          <SlashCommandCardType>Chart</SlashCommandCardType>
        </SlashCommandCardInfo>
      </SlashCommandCardHeader>
      <SlashCommandCardBody $isEditMode={false}>
        <SlashCommandCardMeta>
          {chart?.name && <span>Name: {chart?.name}</span>}
          {chart?.description && <span>Description: {chart?.description}</span>}
        </SlashCommandCardMeta>
        <TimeSeriesScatterplot
          chartID={entryID}
          showChartSettings={false}
          siteID={siteID ?? ''}
          chartContainer={ChartContainer}
          hideSidebar={true}
          hideHeader={true}
          hideFooter={true}
        />
      </SlashCommandCardBody>
    </SlashCommandCard>
  )
}
